import React from 'react'
import TripSegment from '../TripSegment'
// import TripSegment from '../TripSegment'

let TripSegmentList = ({ tripSegments }) => {
  let renderTripSegments = tripSegments.map(
    (tripSegment, i) => <TripSegment key={i} tripSegment={tripSegment} />
  )

  return <div>{renderTripSegments}</div>
  // return <div>{tripSegments[0].id}</div>
}

export default TripSegmentList



// WEBPACK FOOTER //
// ./src/components/TripSegmentList/index.js